<div id="dropin-container"></div>

@if (!braintreeDropInLoaded()) {
  <div class="loading-wrapper">
    <app-loading-spinner/>
  </div>
}
